module.exports = __webpack_public_path__ + "static/media/ic_head11.fa9bfe57.png";